import "flyonui/flyonui";
import './lib/localuser.js';
import LambdaCountdown from "./lib/countdown";
import LambdaCountdownEvent from "./lib/countdown-event";
import LambdaCountdownSimple from './lib/countdown.simple.js';
import ClipboardJS from "clipboard";
import MusicKitPreview from './lib/musickit-preview.js';
import LambdaPixelShaders from './lib/shaders.js';
import LambdaSeasonalEffects from './lib/seasonal.js';
window.ClipboardJS = ClipboardJS;
import clipboardHelper from './lib/clipboard-helper.js';
import './bootstrap';
import LambdaLightbox from "./lib/lightbox.js";
import './lib/emoji.js';
import './lib/user.popup.js';
import './lib/forum.presence.js';
import './lib/site.presence.js';
import './lib/global.search.js';
import './lib/forum.rewards.js';
import 'nouislider';
import './lib/latency.ui.js';
import './lib/latency.tester.js';
import './lib/latency.manager.js';
import './lib/timestamp-formatter.js';
import './lib/syntax-highlighting.js';

document.addEventListener('livewire:init', () => {

	LambdaLightbox.registerEvents();

	Livewire.on('refresh-flyonui', (event) => {

		setTimeout(() => {
			window.HSStaticMethods.autoInit();
		}, 1000);


	});

	Livewire.on('sync-action-modals', (event) => {

		window.dispatchEvent(new CustomEvent("close-page-mobile-menu"));

	});

});

document.addEventListener('livewire:navigated', () => {

	LambdaLightbox.registerMarkdownListener();
    LambdaCountdownEvent.initEventCountdowns();
	LambdaCountdownSimple.initSimpleCountdowns();

    window.HSStaticMethods.autoInit();

	clipboardHelper('.js-clipboard');

	LatencyManager.init();
	LatencyUI.updateUIElements();
	MusicKitPreview.init();
	LambdaPixelShaders.init();
	LambdaSeasonalEffects.init();

});

document.addEventListener('livewire:navigating', () => {

	LambdaSeasonalEffects.rememberPageLayer();

});

document.addEventListener('DOMContentLoaded', () => {

    //LambdaCountdownEvent.initEventCountdowns();

});

window.Echo.private(`App.Models.User.${window.UserID}`).listen('.lambdanet-lobby-invite', (e) => {

	new FilamentNotification()
		.title("New Lobby Invite!")
		.info()
		.body(`${e.inviterName} has invited you to join their ${e.lobbyGamemode} lobby!`)
		.duration(10000)
		.actions([
			new FilamentNotificationAction('join')
				.button()
				.label('Accept')
				.url(e.lobbyUrl)
				.color('success'),
			new FilamentNotificationAction('ignore')
				.button()
				.label('Ignore')
				.color('gray')
				.close()
		])
		.send();

	let audio = new Audio(`${window.location.origin}/assets/sound/notifications/lobby-invite.mp3`);
	audio.volume = 0.5;
	audio.play();

}).listen('.lambdanet-lobby-player-kicked', (e) => {

	window.location.href = e.redirectUrl;

	new FilamentNotification()
		.title("Kicked")
		.danger()
		.body(`You have been kicked from ${e.lobbyName}`)
		.send();

});

window.LambdaCountdown = LambdaCountdown;
